/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_DataInputs */



/**
* | output |
* | --- |
* | "Data" |
*
* @param {Profile_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_data = /** @type {((inputs?: Profile_DataInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_DataInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Données")
	if (locale === "es") return /** @type {LocalizedString} */ ("Datos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Dados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dati")
	return /** @type {LocalizedString} */ ("Data")
});